import { render } from "./DessinMobile.vue?vue&type=template&id=205bc044"
import script from "./DessinMobile.vue?vue&type=script&lang=js"
export * from "./DessinMobile.vue?vue&type=script&lang=js"

import "./DessinMobile.vue?vue&type=style&index=0&id=205bc044&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__